import { Injectable, inject } from "@angular/core";
import { AlertController } from "@ionic/angular";
import { opsControlService } from "./ops-control/ops-control.service";
import { classCom } from "../plugins/opsctrl-foc/focMain";

@Injectable({ providedIn: "root" })
export class FlightEntryService {
  private ops = inject(opsControlService);
  private alerts = inject(AlertController);

  protected get activeDutyId(): string {
    return classCom?.activeDutyId;
  }

  get issue(): string {
    const duty = this.ops.currentDutyOfpLimits;
    if (!duty?.signature || !duty.missionLimits) return "Sign duty limits before creating a flight.";
    if (!(Number(duty.dutyFrom) <= Date.now() && Number(duty.dutyTo) > Date.now())) {
      return "Your signed duty is no longer valid. Sign duty limits again before creating a flight.";
    }
    if (this.activeDutyId == null || String(this.activeDutyId).trim() === "") {
      return "The signed duty could not be found. Open duty signing before creating a flight.";
    }
    return "";
  }

  get ready(): boolean {
    return this.issue === "";
  }

  async ensureReady(): Promise<boolean> {
    let refreshed = false;
    try {
      refreshed = await this.ops.checkDutyLimitsValid();
    } catch (error) {
      console.error("Flight entry duty check failed", error);
    }
    if (refreshed && this.ready) return true;
    const alert = await this.alerts.create({
      header: "Duty signing required",
      message: this.issue || "Duty data could not be verified. Open duty signing before creating a flight.",
      backdropDismiss: false,
      buttons: ["Open duty signing"],
    });
    await alert.present();
    await alert.onDidDismiss();
    return false;
  }
}
